export default {
  YOUR_EVENTS: 'Sus eventos',
  ADD_EVENTS: 'Añadir evento',
  NO_EVENTS: 'Aún no ha añadido ningún evento!',
  ENTER: 'Introducir',
  EVENT_NAME: 'Nombre del evento',
  START_DATE: 'Fecha de inicio',
  END_DATE: 'Fecha final',
  LOCATION: 'Lugar',
  TIMEZONE: 'Zona horaria',
  EVENT_CONFIG: 'Configurar evento',
  API_KEY: 'Clave API',
  ARCHIVE_DAYS: 'Días de archivo',
  ARCHIVE_DAYS_LABEL: 'Días para archivar tras el final del evento',
  GDPR_CONFIG: 'Configurar GDPR',
  GDPR_CONSENT: 'Consentimiento GDPR',
  GDPR_TITLE: 'Título GDPR',
  GDPR_DESC: 'Descripción de GDPR',
  GDPR_APPROVE_LABEL: 'Etiqueta del botón de aprobación de GDPR',
  GDPR_CANCEL_LABEL: 'Etiqueta de botón de cancelación GDPR',
  ADD_EVENT: 'Añadir evento',
  ADD_EVENT_SUCCESS: '¡Su evento ha sido creado correctamente!'
}
